import { useMediaQuery } from '@vueuse/core';

const serverDeviceWidth = 376; // make sure this number only matches one of the breakpoints below

export const useDevice = () => {
    const isMobileSmall = useMediaQuery('screen and (max-width: 23.4375em)', {
        ssrWidth: serverDeviceWidth
    });
    const isMobile = useMediaQuery('screen and (max-width: 31.25em)', {
        ssrWidth: serverDeviceWidth
    }); // update variables-responsive.less as well when changing this
    const isTablet = useMediaQuery('screen and (min-width: 31.3125em) and (max-width: 64em)', {
        ssrWidth: serverDeviceWidth
    }); // update variables-responsive.less as well when changing this
    const isDesktop = useMediaQuery('screen and (min-width: 64.0625em)', {
        ssrWidth: serverDeviceWidth
    }); // update variables-responsive.less as well when changing this
    const isDesktopLarge = useMediaQuery('screen and (min-width: 81.25em)', {
        ssrWidth: serverDeviceWidth
    }); // update variables-responsive.less as well when changing this
    const isDesktopXLarge = useMediaQuery('screen and (min-width: 100em)', {
        ssrWidth: serverDeviceWidth
    });

    const prefersContrast = useMediaQuery('(prefers-contrast)'); // make sure to only use in Client context to prevent hydration mismatches
    const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion)'); // make sure to only use in Client context to prevent hydration mismatches

    const isSafari = computed(() => {
        return /^((?!chrome|android).)*safari/i.test(navigator?.userAgent) ?? false;
    });

    return {
        isMobileSmall,
        isMobile,
        isTablet,
        isDesktop,
        isDesktopLarge,
        isDesktopXLarge,
        prefersContrast,
        prefersReducedMotion,
        isSafari
    };
};
